// This file is generated by pnpm icons:generate. Do not edit.

import {Reply as CanonicalReply} from './brands/Reply'
import {createSinglePathSVG} from './TEMPLATE'

export const Reply_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 2.25a9.75 9.75 0 0 0-8.608 14.333l-1.064 3.192a1.5 1.5 0 0 0 1.897 1.897l3.192-1.064A9.75 9.75 0 1 0 12 2.25Zm0 18a8.24 8.24 0 0 1-4.13-1.107.75.75 0 0 0-.614-.063L3.75 20.25l1.17-3.506a.75.75 0 0 0-.063-.613A8.25 8.25 0 1 1 12 20.25Z',
  viewBox: '0 0 24 24',
  glyph: 'Reply_Stroke2_Corner0_Rounded',
})

/** @deprecated Import Reply from `#/components/icons/brands/Reply` instead. */
export const Reply = CanonicalReply
